<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 d-flex justify-content-center align-items-center" style="height: 100vh; background-color: #f5f5f5;">
            <div class="card card_style d-flex flex-column px-5 pt-2">
                <div class="col-md-12 d-grid align-items-center justify-content-center">
                    <i class="bi bi-exclamation-triangle" style="align-self: center; font-size: 3rem;"></i>
                </div>
                <label class="mt-2" style="align-self: center; font-weight: bold;">{{ 'AttentionU' | translate }}</label>
                <label class="mt-2" style="align-self: center; font-weight: 500; white-space: nowrap;">Page not found!</label>
                <button class="btn btn_style mt-4 d-grid align-content-center px-3" (click)="onReturnButton()">
                    <label style="cursor: pointer;">Torna alla home</label> 
                </button>
            </div>
        </div>
    </div>
</div>